<script setup lang="ts">
import type { FilesystemJs } from "@/generated/models";
import NodeIcon from "ls/features/icons/NodeIcon.vue";
import { LibraryBigIcon, PanelsTopLeftIcon, UserRoundIcon } from "lucide-vue-next";
import { computed } from "vue";
import { getIconFallbackLetter } from "../icons/utils";
import { isLibraryWorkspace, isTemplateWorkspace } from "./utils";

const props = defineProps<{
  workspace: FilesystemJs;
}>();

const fallbackLetter = computed(() => getIconFallbackLetter(props.workspace.DisplayName));
</script>

<template>
  <LibraryBigIcon v-if="isLibraryWorkspace(workspace)" class="size-4" aria-hidden="true" />
  <PanelsTopLeftIcon v-else-if="isTemplateWorkspace(workspace)" class="size-4" aria-hidden="true" />
  <UserRoundIcon v-else-if="workspace.IsDefaultFs" class="size-4" aria-hidden="true" />
  <NodeIcon
    v-else
    variant="boxed"
    class="size-5"
    :letter="fallbackLetter"
    :shortcut="workspace.Shortcut"
    :icon="workspace.IconData"
  />
</template>
